import * as Sentry from "@sentry/react";
import { fetchAuthSession, signIn } from "aws-amplify/auth";
import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import useAlreadyLoggedIn from "../../hooks/useAlreadyLoggedIn";
import useAuthStore from "../../stores/authStore";

export default function useLogin() {
  useAlreadyLoggedIn();
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const handleSubmit = useCallback(
    (values, { setSubmitting }) => {
      setSubmitting(true);
      const { username, password } = values;
      signIn({ username, password })
        .then(async ({ nextStep }) => {
          if (nextStep.signInStep === "CONFIRM_SIGN_UP") {
            navigate("/auth/register/confirm", { state: { username } });
            return;
          }
          if (nextStep.signInStep !== "DONE") {
            setError("Unable to sign in. Please contact support.");
            return;
          }
          const session = await fetchAuthSession();
          const { tokens } = session;
          useAuthStore.getState().setCredentials({
            accessToken: tokens.accessToken.toString(),
            idToken: tokens.idToken.toString(),
            idTokenPayload: tokens.idToken.payload,
          });
        })
        .catch((err) => {
          if (err.name === "UserNotConfirmedException") {
            navigate("/auth/register/confirm", { state: { username } });
            return;
          }
          Sentry.captureException(err);
          setError(err.message || JSON.stringify(err));
        })
        .finally(() => {
          setSubmitting(false);
        });
    },
    [navigate],
  );

  return useMemo(() => ({ handleSubmit, error }), [handleSubmit, error]);
}
